module.exports = __webpack_public_path__ + "static/img/pwd@3x.89c4cacf.png";